import ContractPart from './active_record/contract_part'
import {t} from '@eitje/bridge'

class UserEmploymentType extends ContractPart {
	static tableName = 'userEmploymentTypes'
	static defaultJoins = ['employmentTypes']
	static sort = {field: 'start_date', direction: 'desc'}

	isFixed = () => {
		return this.name == 'Uren contract'
	}

	sanitizedName() {
		if (this.name == 'Nul uren') return 'flex'
		if (this.name == 'Uren contract') return 'fixed'
		if (this.name == 'Payroll') return 'payroll'
		return 'self_employed'
	}

	translatedName() {
		return t(`common.${this.sanitizedName()}`)
	}
}

export default UserEmploymentType
